/**
 * <Email
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { Component } from 'react';
import classnames from 'classnames'
import validator from 'validator';

export function validateRadio(value) {
  if(!value){
    return {
      ok: false,
      failed: {
        because: ['required'],
        value
      }
    }
  }
}

class Radio extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
  }

  render() {
    const {
      value,
      onChange,
      options,
    } = this.props;

    return (
      <div className={classnames('Radio')}>
        {options.map((option, key)=>{
          if (typeof option.value === 'undefined') {
            throw new Error('{ value, label } are required.');
          }
          return <label className='control'><input type='radio' key={key} checked={value == option.value} value={option.value} onChange={(e)=>{ onChange(option.value); }} /><span className='radiomark'></span> {option.label}</label>
        })}
      </div>
    );
  }
}

export default Radio;



// WEBPACK FOOTER //
// ./src/components/Form/Fields/Radio/index.js